import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=814a76b6&scoped=true&"
import script from "./Hero.vue?vue&type=script&lang=js&"
export * from "./Hero.vue?vue&type=script&lang=js&"
import style0 from "./Hero.vue?vue&type=style&index=0&id=814a76b6&lang=scss&scoped=true&"
import style1 from "./Hero.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "814a76b6",
  null
  
)

component.options.__file = "Hero.vue"
export default component.exports